export default {"src":"/_next/static/media/yardzen-logo-mobile.c2b59b20.svg","height":33,"width":27,"blurWidth":0,"blurHeight":0};